import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import styles from './styles.module.scss'

export const CollapsibleSection = ({ title, summary, children, defaultExpanded = true }) => {
  return (
    <Accordion defaultExpanded={defaultExpanded} elevation={0} className={styles.accordion}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
        <Box className={styles.summaryContainer}>
          <Typography variant="h5" fontWeight={700}>
            {title}
          </Typography>
          {summary && (
            <Typography variant="body2" color="textSecondary" className={styles.summary}>
              {summary}
            </Typography>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}
